<div class="row multiple-file">
  <ng-container *ngIf="haveErrorResult">
    <div class="col-12" *ngIf="isUser && dataUploadFile && dataUploadFile.code==='IMPORTED_EXCEL_LIST_USER'">
      <span>{{'hint.title_result' | translate}}</span>
      <span class="text-primary-new">&nbsp;{{'hint.title_success' | translate}}</span>
      <span>&nbsp;{{dataUploadFile.data.totalRecordSuccess}} {{'hint.title_record' | translate}},</span>
      <span class="text-danger" >&nbsp;{{'hint.title_fail' | translate}}</span>
      <span>&nbsp;{{dataUploadFile.data.totalRecordFail}} {{'hint.title_record' | translate}}</span>
      <br>
      <span>{{'hint.attach_accept_download' | translate}}</span>
      <br>
    </div>
    <div class="col-sm-7 pl-3">
        <span class="fix-width">
          <em class="fa fa-file fa-fw text-primary"></em>
          <a href="#" (click)="downResultImport($event)"> {{resultImportExcelName}}</a>
        </span>
    </div>
    <div class="col-sm-3 text-right">
        <span>
        </span>
    </div>
    <div class="col-sm-2 text-right">
        <span>
          <button type="button" class="btn-none">
            <em class="fa fa-download fa-fw text-primary" (click)="downResultImport($event)" matTooltip="Tải file"></em>
          </button>
        </span>
    </div>
  </ng-container>
</div>

<div *ngIf="!haveErrorResult">
  <!-- tệp đính kèm -->
  <div *ngFor="let item of arrAttachments" class="row multiple-file">
    <ng-container *ngIf="item.name != undefined;">
      <div class="col-sm-7 pl-3">
        <span class="fix-width" [matTooltip]="item.name">
          <em class="fa fa-file fa-fw text-primary"></em>
          {{item.name}}
        </span>
      </div>
      <div class="col-sm-3 text-right">
        <span>
          {{item.size | byte}}
        </span>
      </div>
      <div class="col-sm-2 text-right">
        <span>
          <button type="button" class="btn-none">
            <em class="fa fa-trash fa-fw text-danger" (click)="deleteFile(item)" matTooltip="{{'tooltips.delete' | translate}}"></em>
          </button>
        </span>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!isViewDetail" class="mt-3 text-center">
    <button mat-stroked-button color="primary" type="button" (click)="inputUpload.click()" class="mb-1">
      <mat-icon class="mr-0">cloud_upload</mat-icon> {{'form.select_attach' | translate}}
    </button>
    <input type="file" #inputUpload id="files" class="form-control-file vt-input-form d-none" name="files" (change)="getFiles($event)" accept=".xlsx" />
    <small *ngIf="maxSizeInput" class="form-text text-danger">{{'validation.file' | translate}}</small>
    <small *ngIf="errorFormatTypeFile" class="form-text text-danger">{{'messages.file_type' | translate}}</small>
  </div>
</div>

